import { render, staticRenderFns } from "./Cria_EmpresasUni.vue?vue&type=template&id=2a5630b3&scoped=true&"
import script from "./Cria_EmpresasUni.vue?vue&type=script&lang=js&"
export * from "./Cria_EmpresasUni.vue?vue&type=script&lang=js&"
import style0 from "./Cria_EmpresasUni.vue?vue&type=style&index=0&id=2a5630b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5630b3",
  null
  
)

export default component.exports